//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

export type CallbackStatus = "idle" | "calling" | "success" | "failed";

type StartCallback = { type: "startCallback" };
type CallbackSuccess = { type: "callbackSuccess" };
type CallbackFailed = { type: "callbackFailed" };
type SetCopied = { type: "setCopied" };

export type ExternalApiCodeAction =
    | StartCallback
    | CallbackSuccess
    | CallbackFailed
    | SetCopied;

export interface ExternalApiCodeState {
    callbackStatus: CallbackStatus;
    copied: boolean;
}

export function reducer(
    state: ExternalApiCodeState,
    action: ExternalApiCodeAction
): ExternalApiCodeState {
    switch (action.type) {
        case "startCallback":
            return { ...state, callbackStatus: "calling" };
        case "callbackSuccess":
            return { ...state, callbackStatus: "success" };
        case "callbackFailed":
            return { ...state, callbackStatus: "failed" };
        case "setCopied":
            return { ...state, copied: true };
    }
}
